<template>
  <div class="relative">
    <div
      v-if="loading"
      class="absolute inset-0 z-10 flex items-center justify-center bg-background/80 backdrop-blur-sm"
    >
      <Spinner :size="size" :label="label" />
    </div>
    <div :class="{ 'opacity-50': loading }">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Spinner } from '../spinner'

interface Props {
  loading?: boolean
  size?: 'sm' | 'md' | 'lg' | 'xl'
  label?: string
}

withDefaults(defineProps<Props>(), {
  loading: false,
  size: 'md'
})
</script>